import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import MakeAPICall from "../../apiCalls/common";

import {
  // getConsultsApiRoute,
  getConsultDetailsApiRoute,
  sessionsApiRoute,
  sessionsWithFilterApiRoute,
  exportConsultHistoryApiRoute,
  exportMedicareConsultHistoryApiRoute,
  exportAbaFileConsultHistoryApiRoute
} from "../../apiRoutes";

import {
  getFormattedDate,
  converToUtc,
  convertToBrisbaneTimeWithStartDay,
  convertToBrisbaneTimeWithEndDay
} from "../../utils/dateTimeHelper";
import { sortData } from "../../utils/commonMethods";

import appRoutes from "../../routes/appRoutes";

import Loader from "../../components/loader";
import Button from "../../components/button";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTableSearchByFilter from "../../components/datatable/customDataTableSearchByFilter";
import CustomModal from "../../components/modal";
import DeviceDetails from "../../components/deviceDetails";
import ICCheckbox from "../../components/form/checkbox";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import MedicareClaimsExport from "../../containers/ConsultHistory/MedicareClaimsExport";
import medicareImg from "../../assets/images/medicare-button.png";
import AbaFileExport from "../../containers/ConsultHistory/AbaFileExport";

import searchFilterList from "../../constants/searchFilterList";

const PastConsultsPage = props => {
  let history = useHistory();
  const [startDate, setStartDate] = useState(moment().subtract(7, "days").startOf("day"));
  const [endDate, setEndDate] = useState(moment().endOf("day"));
  // const [filter, setFilter] = useState(null);
  const [consultNatureFilter, setConsultNatureFilter] = useState(null);
  const [consultDurationFilter, setConsultDurationFilter] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  // const [apiCallParams1, setApiCallParams1] = useState(null);
  const [isBookedConsult, setIsBookedConsult] = useState(false);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit
      }
      : {
        skip: 0,
        limit: 10
      }
  );
  const [consults, setConsults] = useState([]);
  // const [consultsNatureList, setConsultsNatureList] = useState([]);
  const [consultDurationList, setConsultDurationList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");
  const [openMedicareCSVModal, setOpenMedicareCSVModal] = useState(false);

  const [showAbaFileExportModal, setShowAbaFileExportModal] = useState(false);

  // filter added
  const [filterConnectionIssueByDoc, setFilterConnectionIssueByDoc] = useState(false);

  const tableHeaders = [
    {
      key: "newAppointMentID",
      value: "Consult ID"
    },
    { key: "createdAt", value: "Consult Date" },
    { key: "doctorName", value: "Practitioner Details" },
    { key: "patientName", value: "Patient Details" },
    { key: "deviceDetails", value: "Device Details" }
  ];

  const goToConsultDetailPage = id => {
    history.push(appRoutes.pastConsults + "/" + id, {
      currPageNo: currFilters
    });
  };

  // get consult nature list
  // const getConsultNatureList = () => {
  //   setApiCallParams1({
  //     reqType: "GET",
  //     reqUrl: getConsultsApiRoute,
  //     params: {
  //       skip: 0,
  //       limit: 0
  //     },
  //     successCallback: async res => {
  //       let list = [];
  //       await res.data.data.consultData.forEach(column => {
  //         let d = {};
  //         d._id = column._id;
  //         if (column.consultName && column.consultName !== "") {
  //           d.consultName = column.consultName;
  //         } else {
  //           d.consultName = "";
  //         }
  //         list.push(d);
  //       });
  //
  //       setConsultsNatureList(list);
  //     },
  //     failureCallback: err => {
  //       // setErrModalText(
  //       //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //       // );
  //       // setShowErrModal(true);
  //     }
  //   });
  // };

  // get consult duration list
  const getConsultDurationList = () => {
    setApiCallParams2({
      reqType: "GET",
      reqUrl: getConsultDetailsApiRoute,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        await res.data.data.consultDetailData.forEach(column => {
          let d = {};
          d._id = column._id;
          d.consultDuration =
            column.consultMode + " " + column.consultDuration + " Mins";
          list.push(d);
        });
        setConsultDurationList(list);
      },
      failureCallback: err => {
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get past consults
  const getConsults = () => {
    setIsProcessing(true);

    let apiUrl = sessionsApiRoute;
    let params = Object.assign(
      {
        type: "PAST"
      },
      currFilters
    );

    if (currFilters.text && currFilters.text.trim().length > 0) {
      apiUrl = sessionsWithFilterApiRoute;
    } else {
      delete params.text;
      delete params.filterType;
    }

    if (filterConnectionIssueByDoc) {
      params["isConnectionIssueReportedByDoc"] = true;
    }
    currFilters.isBookedConsult = isBookedConsult;


    setApiCallParams({
      reqType: "GET",
      reqUrl: apiUrl,
      params: params,
      successCallback: async res => {
        let list = [];
        await res.data.data.appointments.forEach(column => {
          let d = {};
          if (column.nurseId && column.nurseId !== "") {
            column.doctorId = column.nurseId;
            column.doctorId.doctorId = column.nurseId.nurseId;
          }
          if (column.deviceDetails) {
            d.deviceDetails = column.deviceDetails;
          } else {
            d.deviceDetails = "";
          }

          d.appointmentId = column._id;
          d.newAppointMentID = column.appointmentId;

          if (column.patientId !== null) {
            d.patientEmail = column.patientId.email.replace(/#/gi, "");
            d.patientPhoneNo = column.patientId.phoneNumber;
            d.patientName = column.patientId.firstName;

            if (
              column.patientId.middleName !== "" ||
              column.patientId.middleName !== null ||
              column.patientId.middleName !== undefined ||
              column.patientId.middleName !== "undefined"
            ) {
              d.patientName = d.patientName + " " + column.patientId.middleName;
            }
            d.patientName = d.patientName + " " + column.patientId.lastName;
          } else {
            d.patientEmail = "";
            d.patientPhoneNo = "";
            d.patientName = "";
          }

          d.createdAt = getFormattedDate(column.createdAt);

          if (column.doctorId) {
            d.doctorEmail = column.doctorId.email;
            d.doctorPhoneNo = column.doctorId.phoneNumber;
            d.doctorName = column.doctorId.firstName;

            if (
              column.doctorId.middleName !== "" ||
              column.doctorId.middleName !== null ||
              column.doctorId.middleName !== undefined ||
              column.doctorId.middleName !== "undefined"
            ) {
              d.doctorName = d.doctorName + " " + column.doctorId.middleName;
            }

            d.doctorName = d.doctorName + " " + column.doctorId.lastName;
          } else {
            d.doctorPhoneNo = "";
            d.doctorEmail = "";
            d.doctorName = "";
          }

          d.haveConnectionIssue = column.haveConnectionIssue;

          if (
            column.doctorConnectionAttempt !== undefined &&
            column.doctorConnectionAttempt !== null
          ) {
            d.doctorConnectionAttempt = column.doctorConnectionAttempt;
          }

          if (
            column.patientConnectionAttempt !== undefined &&
            column.doctorConnectionAttempt !== null
          ) {
            d.patientConnectionAttempt = column.patientConnectionAttempt;
          }

          if (
            column.haveConnectionIssue === true &&
            column.markedunsuccess !== true
          ) {
            d.rowStyle = {
              backgroundColor: "#ff8fec",
              color: "#000"
            };
          } else if (column.markedunsuccess === true) {
            d.rowStyle = {
              backgroundColor: "#e6e6e6",
              color: "#000"
            };
          } else if (
            column.isPhoneCallUsed !== undefined &&
            column.isPhoneCallUsed === true
          ) {
            d.rowStyle = {
              backgroundColor: "#f0e2d3",
              color: "#000"
            };
          } else {
            d.rowStyle = {
              backgroundColor: "#fff",
              color: "#656565"
            };
          }

          list.push(d);
        });

        setConsults(list);
        setTotalRecords(res.data.data.count);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // get medicare CSV modal status
  const closeMedicareCSVModal = () => {
    setOpenMedicareCSVModal(false);
  };

  const getOpenMedicareCSVModal = () => {
    setOpenMedicareCSVModal(true);
  };

  // export past consults
  const exportConsults = async () => {
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("which", "PAST");

    if (
      // filter &&
      // filter === "1" &&
      startDate !== null &&
      endDate !== null &&
      startDate <= endDate
    ) {
      formData.append("startDate", converToUtc(startDate));
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
      formData.append("endDate", converToUtc(dt));
    }

    await setApiCallParams({
      reqType: "POST",
      reqUrl: exportConsultHistoryApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        var fileURL = res.data.data;
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = "Past_Consults.csv";
        document.body.appendChild(a); //create the link "a"
        a.click(); //click the link "a"
        document.body.removeChild(a); //remove the link "a"
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export medicare consults
  const exportMedicareConsults = formData => {
    closeMedicareCSVModal();
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: exportMedicareConsultHistoryApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        var fileURL = res.data.data;
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = "Past_Medicare_Consults.csv";
        document.body.appendChild(a); //create the link "a"
        a.click(); //click the link "a"
        document.body.removeChild(a); //remove the link "a"
      },
      failureCallback: err => {
        setIsProcessing(false);
        if (err.message) {
          setErrModalText(
            `Export to eClaims Unsuccessful <br /> ${err.message}`
          );
        } else if (err && err.message) {
          setErrModalText(err.message);
        } else {
          setErrModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
        }
        setShowErrModal(true);
      },
      showErrPopup: false
    });
  };

  // aba file modal status
  const closeAbaFileExportModal = () => {
    setShowAbaFileExportModal(false);
  };

  const openAbaFileExportModal = () => {
    setShowAbaFileExportModal(true);
  };

  // export aba file
  const exportAbaFileConsults = formData => {
    closeAbaFileExportModal();
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: exportAbaFileConsultHistoryApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        var fileURL = res.data.data;
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = "ABA_Consults.aba";
        document.body.appendChild(a); //create the link "a"
        a.click(); //click the link "a"
        document.body.removeChild(a); //remove the link "a"
      },
      failureCallback: err => {
        setIsProcessing(false);

        if (err.message === "No Consult Found") {
          setErrModalText("No Consult Found");
        } else if (err && err.message) {
          setErrModalText(err.message);
        } else {
          setErrModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
        }

        setShowErrModal(true);
      },
      showErrPopup: false
    });
  };

  useEffect(() => {
    // if (consultsNatureList.length === 0) {
    //   getConsultNatureList();
    // }

    if (consultDurationList.length === 0) {
      getConsultDurationList();
    }

    getConsults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters, filterConnectionIssueByDoc]);

  // restore the previous page state
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.currPageNo &&
      props.location.state.currPageNo !== null
    ) {
      setCurrFilters({
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit
      });
    }

    applySelectedFilter();
  }, []);

  // const handleFilterChange = event => {
  //   setFilter(event.target.value);
  // };

  const handleStartDateChange = date => {
    setStartDate(date);
    applySelectedFilter(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
    applySelectedFilter('', date);
  };

  const handleConsultNatureFilterChange = e => {
    if (e.target.value === "0") {
      setConsultNatureFilter(null);
    } else {
      setConsultNatureFilter(e.target.value);
    }
    applySelectedFilter(null, null, e.target.value);
  };

  const handleConsultDurationFilterChange = e => {
    if (e.target.value === "0") {
      setConsultDurationFilter(null);
    } else {
      setConsultDurationFilter(e.target.value);
    }

    applySelectedFilter(null, null, null, e.target.value);
  };

  // const clearFilter = () => {
  //   setStartDate(null);
  //   setEndDate(null);
  //   setFilter(null);
  //   setConsultNatureFilter(null);
  //   setConsultDurationFilter(null);
  //   let newFilter = Object.assign({}, currFilters);
  //   newFilter.skip = 0;
  //   if (newFilter.startDate) {
  //     delete newFilter.startDate;
  //   }
  //   if (newFilter.endDate) {
  //     delete newFilter.endDate;
  //   }
  //   if (newFilter.consultId) {
  //     delete newFilter.consultId;
  //   }
  //   if (newFilter.consultDetailId) {
  //     delete newFilter.consultDetailId;
  //   }
  //   setCurrFilters(newFilter);
  // };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    newFilter.filterType = filters.filterType;

    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, consults);
    setConsults(sortedData);
  };

  const applySelectedFilter = (sDate, eDate, consultNatureId, consultDurationId) => {
    let newFilter = Object.assign({}, currFilters);

    newFilter.skip = 0;

    if (newFilter.startDate) {
      delete newFilter.startDate;
    }
    if (newFilter.endDate) {
      delete newFilter.endDate;
    }
    if (newFilter.consultId) {
      delete newFilter.consultId;
    }
    if (newFilter.consultDetailId) {
      delete newFilter.consultDetailId;
    }

    let newStartDate = sDate || startDate;
    let newEndDate = eDate || endDate;

    console.log("------------- sDate: ", sDate);
    console.log("------------- dDate: ", eDate);
    if (
      // filter === "1" &&
      // startDate !== null &&
      // endDate !== null &&
      newStartDate <= newEndDate
    ) {
      newFilter.startDate = convertToBrisbaneTimeWithStartDay(newStartDate);
      // let dt = new Date(
      //   newEndDate.get("year"),
      //   newEndDate.get("month"),
      //   newEndDate.get("date") + 1,
      //   0,
      //   0,
      //   0
      // ).toISOString();
      newFilter.endDate = convertToBrisbaneTimeWithEndDay(newEndDate);
      setCurrFilters(newFilter);
    }

    // if (filter === "2" && consultNatureFilter !== null) {
      newFilter.consultId = consultNatureId || consultNatureFilter;
      setCurrFilters(newFilter);
    // }

    // if (filter === "3" && consultDurationFilter !== null) {
      newFilter.consultDetailId = consultDurationId||consultDurationFilter;
      setCurrFilters(newFilter);
    // }

  };

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showErrModal}
            cancelEvent={() => {
              setShowErrModal(false);
              setErrModalText("");
            }}
            modalBodyContent={
              <p
                className="text-center mb-0"
                dangerouslySetInnerHTML={{
                  __html: errModalText
                }}
              ></p>
            }
          />
          <div className="row flex">
            <h3 className="flex-grow-1">Past Consults</h3>
            <Button
              className="float"
              clickEvent={exportConsults}
              title="Export to CSV"
            ></Button>
            {props.user && props.user.userType === "SUPER_ADMIN" && (
              <Fragment>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  clickEvent={openAbaFileExportModal}
                  title="Export to ABA"
                ></Button>
                <button className="img-button">
                  <img
                    onClick={getOpenMedicareCSVModal}
                    src={medicareImg}
                    alt="medicare CSV Download"
                  />
                </button>
                <CustomModal
                  openModal={openMedicareCSVModal}
                  title="Export Medicare CSV"
                  noFooterButtons={true}
                  modalBodyContent={
                    <MedicareClaimsExport
                      onFormSubmit={exportMedicareConsults}
                    />
                  }
                  cancelEvent={closeMedicareCSVModal}
                />
                <CustomModal
                  openModal={showAbaFileExportModal}
                  title="Export ABA File"
                  noFooterButtons={true}
                  modalBodyContent={
                    <AbaFileExport onFormSubmit={exportAbaFileConsults} />
                  }
                  cancelEvent={closeAbaFileExportModal}
                />
              </Fragment>
            )}
          </div>
          <div className="d-flex flex-row flex-wrap justify-content-between mt-4">
            <div>
              <ICCheckbox
                name="filterConnectionIssueByDoc"
                onChange={(event, value) => {
                  setFilterConnectionIssueByDoc(value);
                  applySelectedFilter();
                }}
                value={filterConnectionIssueByDoc}
                checked={filterConnectionIssueByDoc}
                label="Connection Issue Reported"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </div>

            <div className="d-flex flex-row align-items-end">
              <div className="d-flex flex-row align-items-end">
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isBookedConsult"
                        className="ic-checkbox"
                        onChange={e => {setIsBookedConsult(e.target.checked); 
                          setCurrFilters({...currFilters, isBookedConsult:e.target.checked
                          })}}
                        checked={isBookedConsult}
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    }
                    className="mb-n5"
                    label="Bookings"
                    labelPlacement="end"
                  />
                  <KeyboardDatePicker
                    name="startDate"
                    style={{ width: "135px" }}
                    autoOk
                    variant="inline"
                    mask="__-__-____"
                    format="DD-MM-YYYY"
                    label="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                  />
                  <KeyboardDatePicker
                    name="endDate"
                    style={{ width: "135px", marginLeft: "20px" }}
                    autoOk
                    variant="inline"
                    mask="__-__-____"
                    format="DD-MM-YYYY"
                    label="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                  />
                </div>

                <TextField
                  className="ml-4"
                  select
                  SelectProps={{
                    native: true
                  }}
                  onChange={handleConsultNatureFilterChange}
                >
                  <option value="0">Select Nature of Consult</option>
                  {props.consultNatureList.map((item, i) => (
                    <option key={i} value={item._id}>
                      {item.consultName}
                    </option>
                  ))}
                </TextField>

                {/*<TextField*/}
                {/*  className="ml-4"*/}
                {/*  select*/}
                {/*  SelectProps={{*/}
                {/*    native: true*/}
                {/*  }}*/}
                {/*  onChange={handleConsultDurationFilterChange}*/}
                {/*>*/}
                {/*  <option value="0">Select Duration of Consult</option>*/}
                {/*  {consultDurationList.map((item, i) => (*/}
                {/*    <option key={i} value={item._id}>*/}
                {/*      {item.consultDuration}*/}
                {/*    </option>*/}
                {/*  ))}*/}
                {/*</TextField>*/}
                {/*<button*/}
                {/*  style={{ minWidth: "30px", width: "30px" }}*/}
                {/*  className="insta-button-primary ml-3"*/}
                {/*  onClick={applySelectedFilter}*/}
                {/*>*/}
                {/*  <i className="fas fa-arrow-right" aria-hidden="true"></i>*/}
                {/*</button>*/}
                {/*<button*/}
                {/*  style={{ minWidth: "30px", width: "30px" }}*/}
                {/*  className="insta-button-primary ic-btn-red ml-3"*/}
                {/*  onClick={clearFilter}*/}
                {/*>*/}
                {/*  <i className="fa fa-times" aria-hidden="true"></i>*/}
                {/*</button>*/}
              </div>
              {/*&nbsp;&nbsp;&nbsp;&nbsp;*/}
            </div>
          </div>
          <CustomDataTableSearchByFilter
            totalRecords={totalRecords}
            headers={tableHeaders}
            setFilters={setTableFilters}
            sortData={sortTableDataByColumn}
            tabFilters={currFilters}
            disbleAll={true}
            searchFilterList={searchFilterList.pastConsultSearchFilterList}
          >
            {consults.map((item, index) => (
              <tr
                key={index}
                className="row-no-hover-effect"
                style={item.rowStyle}
                onClick={e => {
                  e.preventDefault();
                  goToConsultDetailPage(item.appointmentId);
                }}
              >
                <td>{item.newAppointMentID}</td>
                <td>{item.createdAt}</td>
                <td>
                  <div className="d-flex flex-column position-relative">
                    <p
                      className={
                        item.doctorConnectionAttempt !== 1 &&
                        item.doctorConnectionAttempt !== undefined
                          ? "color-red mb-0"
                          : "mb-0"
                      }
                    >
                      <b>{item.doctorName}</b>
                    </p>
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      className="high-z-index list-email"
                      href={"mailto:" + item.doctorEmail}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.doctorEmail}
                    </a>
                    <ICPhoneDisplay value={item.doctorPhoneNo} />
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-column position-relative">
                    <p
                      className={
                        item.patientConnectionAttempt !== 1 &&
                        item.patientConnectionAttempt !== undefined
                          ? "color-red mb-0"
                          : "mb-0"
                      }
                    >
                      <b>{item.patientName}</b>
                    </p>
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      className="high-z-index list-email"
                      href={"mailto:" + item.patientEmail}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.patientEmail}
                    </a>
                    <ICPhoneDisplay value={item.patientPhoneNo} />
                  </div>
                </td>
                <td>
                  <DeviceDetails data={item.deviceDetails} />
                </td>
              </tr>
            ))}
          </CustomDataTableSearchByFilter>
          {/* API Call */}
          <MakeAPICall apiParam={apiCallParams} />
          {/* <MakeAPICall apiParam={apiCallParams1} /> */}
          <MakeAPICall apiParam={apiCallParams2} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
  consultNatureList: state.serverConstants.consultNatureList
});

export default connect(mapStateToProps, null)(PastConsultsPage);
